export default {"src":"/_next/static/media/phone-call-footer.76ce6487.svg","height":23,"width":23,"blurWidth":0,"blurHeight":0};